<div class="popover {{direction}}">
  <div class="popover__arrow"></div>
  <div class="popover__container">
    <h4 [innerHTML]="popOverContent.title"></h4>
    <ul>
      <li *ngFor="let item of popOverContent.text" [innerHTML]="item" class="popover__item"></li>
    </ul>
  </div>
</div>